/**
 * Created by liuyang on 17/1/12.
 */
import {
  noop,
  isArray,
  isFunction,
  isObject,
  isEmpty,
  reduce,
  extend,
  get,
  set,
  merge as lodashMerge,
  cloneDeep,
  bind,
  isString,
  pick,
  keys,
  values,
  zipObject,
  map,
  each,
  every,
  some,
  concat,
} from 'lodash';
import config from 'config';
import Storage from './Storage';
import {
  sortObjectByKeyNameList
} from 'src/common/Fn';
import LZString from 'lz-string';
import mockFetch from './MockFetch';

// 构建BeforeRunnerFn
const buildRunnerFn = function (before, collection) {
  let defaultBefore = function (init) {
    return init;
  };
  return function (init, params, config, scope) {
    let first = before[0] || defaultBefore;
    let resultFn = before.length >= 2 ? reduce(before, function (pre, next) {
      [pre, next] = map([pre, next], function (item) {
        return bind(isString(item) ? collection[item] : item, scope, bind.placeholder, params, config);
      });
      let ret = pre(init);
      if (isObject(ret) && isFunction(ret.then) && isFunction(ret.catch)) {
        return function () {
          return ret[needCatch ? 'catch' : 'then'](next);
        }
      } else {
        return bind(next, scope, ret);
      }
    }) : bind(isFunction(first) ? first : collection[first], scope);
    return resultFn(init, params, config);
  }
};

// 构建AfterRunnerFn
const buildAfterRunnerFn = function (after, collection) {

  let fns = map(after, function (item) {
    if (isFunction(item)) {
      return [item];
    }
    if (isArray(item)) {
      return map(item, function (it) {
        if(isString(it)) {
          return [get(collection, it)];
        }
        return it;
      })
    }
    if (isString(item)) {
      let fn = get(collection, item);
      return item.indexOf('response.') === 0 ? [fn] : [undefined, fn];
    }
  });
  return function (Response, scope) {
    return reduce(concat(Response, fns), function (response, item) {
      let [thenFn, catchFn] = item;
      if( isFunction(thenFn) ) {
        response = response.then(bind(thenFn, scope));
      }
      if( isFunction(catchFn) ) {
        response = response.catch(bind(catchFn, scope));
      }
      return response;
    });
  }
};

/** Class representing a AjaxModelV2. */

/**
 * @example
 * // 生成一个AJAXModel
 * let model = new AjaxModelV2({
 *   url: '/api/auth/user',
 *   defaultMethod: 'GET'
 * });
 *
 * model.execute({
 *   'user_id': 1
 * }).then(function(data){
 *   console.log(data);
 * }).catch(function(){
 *  Toast({
 *    message: '出错了，请稍后再试',
 *    position: 'bottom'
 *  });
 * })
 *
 * // 和下面代码相同
 * model.get({
 *  'user_id': 1
 * }).then(function(data){
 *  console.log(data);
 * }).catch(function(){data}{
 *  Toast({
 *    message: '出错了，请稍后再试',
 *    position: 'bottom'
 *  });
 * })
 */
class AjaxModelV2 {

  cacheStore = null;

  /**
   * @param {Object} config - model配置项.
   * @param {String} [config.ns] - 空间地址
   * @param {String} [config.domain] - 请求域名
   * @param {String} [config.credentials = include] - `fetch`库当中，跨域请求配置
   * @param {String} [config.redirect = error] - `fetch`库当中，当服务端出现301跳转请求时，前端的响应方式
   * @param {Boolean} [config.bodyUsed = true] - `fetch`库当中，bodyUsed的应用
   * @param {String|function(param)} [config.url] `fetch`库当中，请求的URL参数
   * @param {Object} [config.headers]          - 当前请求的header头部配置
   * @param {String} [config.defaultMethod=POST] - 默认的请求方式
   * @param {String} [config.mode=cors] - 请求方式，是否允许跨域请求
   * @param {String[] | function[] } [config.before] - 前置请求操作
   * @param {String[] | function[]} [config.after] - 后置请求操作
   * @param {Boolean} [config.cache=true] - 是否自动缓存
   * @param {Object} [config.only] - 参数映射
   * @param {Object} [cacheStore]
   *
   */
  constructor(config, cacheStore = null) {
    // 设置请求的store
    if (cacheStore) {
      if( cacheStore instanceof Storage) {
        this.cacheStore = cacheStore;
      } else {
        throw new Error(`cacheStore is not Storage instance!`);
      }
    }
    // 添加配置信息
    this.setConfig(extend({}, AjaxModelV2.defaultConfig, config));

    // 请求参数
    this.queryParams = {};

  }

  /**
   * Validate an object against the schema
   * @returns {object?}
   * @method
   * @name validate
   * @memberOf documents/schema#
   * @param {object=} record The record to validate
   * @param {string|object=} schemaName The name of a previously registered schema
   * @param {object=} options Options to pass to the validator
   * @example
   * // This supports these signatures:
   *
   * instance.validate(record, schemaName, options);
   *
   *
   * instance.validate(); // this, this._defaultSchemaName, this.validationOptions
   * instance.validate(record); // record, this._defaultSchemaName, this.validationOptions
   * instance.validate(schemaName); //this, schemaName, this.validationOptions
   * instance.validate(record, schemaName); //record, schemaName, this.validationOptions
   * instance.validate(schemaName, options); //this, schemaName, this.validationOptions
   */
  validate(){

  }

  /**
   * 快速发送请求
   * @param data
   * @param config
   * @param success
   * @param error
   * @param abort
   * @param progress
   * @param scope
   * @returns {Promise.<{}>}
   */
  execute(data, config, success, error, abort, progress, scope = null) {
    if (isFunction(data)) {
      scope = abort;
      progress = error;
      abort = success;
      error = config;
      success = data;
      config = undefined;
      data = undefined;
    } else if (isFunction(config)) {
      scope = progress;
      progress = abort;
      abort = error;
      error = success;
      success = config;
      config = undefined;
    }
    if(data !== undefined) {
      this.setParams(data);
    }

    let self = this;
    let realConfig = self.getConfig(config);
    let buildRunner = self.beforeRunner(self.getParams(), realConfig);
    let fetchIns;
    if (isFunction(realConfig.drive)) {
      fetchIns = realConfig.drive;
    } else if (realConfig.drive === 'xhr') {
      fetchIns = mockFetch;
    } else {
      fetchIns = fetch;
    }

    let result = buildRunner.then(function (result) {
      let {url} = result;
      delete result['url'];

      return self.cached(result).catch(function () {
        return null;
      }).then(function () {
        return self.afterRunner(fetchIns(url, result, {progress}), realConfig);
      });
    });

    let insertFn = some([success, error, abort], isFunction);

    if (insertFn) {
      result = result.then(success, error);
    }

    return result;
  }

  /**
   * 更改配置
   * @param config
   * @param merge
   * @returns {AjaxModelV2}
   */
  setConfig(config, merge = true) {
    this.config = this.config || {};
    if (merge === true) {
      lodashMerge(this.config, config)
    } else {
      extend(this.config, config);
    }
    if (this.config.cachedToStore === true) {
      if (! (this.cacheStore instanceof Storage)) {
        throw new Error(`cannot find Storage instance`);
      }
    }
  }

  /**
   * 获取配置
   * @returns {{}}
   */
  getConfig(config = true) {
    let realConfig = cloneDeep(this.config);
    if (config === true) {
      return this.config;
    } else if (isObject(config)) {
      lodashMerge(realConfig, config);
    }
    return realConfig;
  }

  /**
   * 设置请求参数
   * @param params
   * @param merge
   */
  setParams(params, merge = false) {
    if (merge === true) {
      lodashMerge(this.queryParams, params);
    } else {
      this.queryParams = params;
    }
  }

  /**
   * 获取请求的参数信息
   * @return {*}
   */
  getParams() {
    return cloneDeep(this.queryParams);
  }

  /**
   * 查询是否开启缓存
   * @return {boolean}
   */
  hasCache(){
    return this.cacheStore && this.getConfig(true).cachedToStore;
  }

  /**
   * 查询缓存内容
   * @param {boolean|undefined|Storage} [cache]
   */
  cache(cache) {
    let config = this.getConfig(true);
    config.cacheStore = !!cache;
  }

  /**
   * 查询当前的缓存信息
   * @param {object} objKeys
   * @return {Promise<*>}
   */
  cached(objKeys){

    if ( this.hasCache() ) {
      let newObjKeys = objKeys;
      if (isObject(objKeys)) {
        newObjKeys = JSON.stringify(sortObjectByKeyNameList(objKeys));
      }
      let cachedKey = LZString.compress(newObjKeys);

      return Promise.resolve(this.cacheStore.get(cachedKey)).then(function (data) {
        return isEmpty(data) ? Promise.reject(null) : data;
      });
    }

    return Promise.reject(null);
  }

  post(data, config, success, error, abort, process, scope = null) {
    return this.execute(data, extend({},config, {method:'POST'}), success, error, abort, process, scope);
  }

  get(data, config, success, error, abort, process, scope = null) {
    return this.execute(data, extend({},config, {method:'GET'}), success, error, abort, process,scope);
  }

  put(data, config, success, error, abort, process, scope = null) {
    return this.execute(data, extend({},config, {method:'PUT'}), success, error, abort, process, scope);
  }

  delete(data, config, success, error, abort, process, scope = null) {
    return this.execute(data, extend({},config, {method:'DELETE'}), success, error, abort, process, scope);
  }

  head(success, config, error, abort, process, scope = null) {
    return this.execute(data, extend({},config, {method:'HEAD'}), success, error, abort, process, scope);
  }

  beforeRunner(params, config, scope) {
    let self = this;

    if (!isFunction(self.__beforeRunner)) {
      self.__beforeRunner = buildRunnerFn(config.before, AjaxModelV2.before);
    }

    let Request = {
      bodyUsed: config.bodyUsed,
      credentials: config.credentials,
      headers: config.headers,
      method: (config.method || config.defaultMethod || '').toUpperCase(),
      mode: config.mode,
      redirect: config.redirect,
      cache: isString(config.cache) ? config.cache : 'default',
      url: config.url
    };
    return Promise.resolve(self.__beforeRunner(Request, params, config, scope || self));
  }

  afterRunner(Response, config, scope) {
    let self = this;

    let keyName = '__afterRunner';

    if (!isFunction(self[keyName])) {
      self[keyName] = buildAfterRunnerFn(config.after, AjaxModelV2.after);
    }

    return self[keyName](Response, scope);
  }

  setBefore(name, replace = false) {

  }

  setAfter(name, replace = false) {

  }

  header(headers, replace = true) {
    let config = this.getConfig(true);

    if (headers === undefined) {

    } else if( replace ) {
      config.headers = headers;
    } else {
      config.headers = extend(config.headers, headers);
    }
    return config.headers;
  }

  merge(sync = false, ...instances) {

  }

  only(keys, replace = true) {
    let config = this.getConfig(true);

    if( keys === undefined ) {
      return config.only;
    } else if (replace === true) {
      config.only = keys;
    } else {
      if(isString(keys)) {
        keys = keys.split(',');
      }
      let toArray = every([keys, config.only], function(item){
        return isEmpty(item) || isArray(item);
      });

      let result = toArray ? [] : {};
      each([keys, config.only], function (item) {
        if (toArray) {
          extend(result, isArray(item) ? zipObject(item, item) : item);
        } else {
          result = concat(result, isEmpty(item) ? [] : item);
        }
      });
      config.only = result;
    }
    return this;
  }

  validate(validate, message) {

  }

  abort() {

  }

  static defaultConfig = {
    ns: 'rest',
    domain: config.restfull,
    credentials: 'include',
    redirect: 'error',
    bodyUsed: true,
    url: noop,
    headers: {},
    defaultMethod: 'POST',
    mode: 'cors',
    before: [],               // 默认的前置处理事件队伍
    after: [],                // 默认后置处理事件队例
    cache: false,                // 表示不需要缓存 ['auto': 表示内存缓存]
    only: null,
    cachedToStore: false,      // 是否需要缓存到系统
    drive: 'fetch',              // 默认使用xhr作驱动
  };

  static before = {
    'only': function (request, params, config) {
      let only = config.only;
      let newParams;

      if (isArray(only)) {
        newParams = pick(params, only);
      } else if (isFunction(only)) {
        newParams = only(params);
      } else if (isObject(only)) {
        newParams = (function (obj, keyMap) {
          let oldKeys = keys(keyMap);
          let newKeys = values(keyMap);
          let picked = pick(obj, oldKeys);
          return zipObject(newKeys, values(picked));
        })(only);
      }

      if (newParams) {
        each(params, function (item, keys) {
          delete params[keys];
        });
        extend(params, newParams);
      }
      return request;
    },
    'url': function (request, params, config) {
      let url = request.url;
      if (isFunction(url)) {
        url = url(params, config);
      }

      let resultFn = function (url) {
        url = [config.domain, config.ns, url].join('/');


        url = url.replace(/:(\w+)/g, function ($0, $1) {
          let param = params[$1] || "";
          delete params[$1];
          return param;
        });

        url = url.replace(/([^:/]\/|^\/)\/+/g, '$1');

        if (url.indexOf('?') === -1) {
          url = url.replace(/\/+$/, '');
        }

        request.url = url;

        return request;
      };

      if(isObject(url) && isFunction(url.then) && isFunction(url.catch)) {
        return url.then(resultFn);
      }

      return resultFn(url);
    },
    'paramsJson': function (request, params, config) {
      request.headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      };

      switch (request.method) {
        case 'GET':
        case 'HEAD':
        case 'TRACE':
        case 'CONNECT':
          let query = AjaxModelV2.serialize(params);
          if (query) {
            request.url += (request.url.indexOf('?') === -1 ? "?" : "&") + query;
          }
          request.body = null;
          break;
        case 'POST':
        case 'PUT':
        case 'DELETE':
          request.body = JSON.stringify(params);
          break;
      }
      return request;
    }
  };

  static after = {
    response: {
      default: function (Response) {
        if (Response.statusText === 'OK' || Response.status == 200) {
          let contentType;
          if (Response.getResponseHeader) {
            contentType = Response.getResponseHeader('Content-Type');
          } else {
            contentType = Response.headers.get('Content-Type');
          }
          switch (contentType) {
            case 'application/json':
              return Object.prototype.toString.call(Response) === '[object XMLHttpRequest]' ? new Function('return ' + Response.responseText)() : Response.json();
          }
        } else {
          return Promise.reject(Response);
        }
      }
    },
    catch: {
      default: function (Response) {
        return Promise.reject(Response);
      }
    },
    finial: {
      default: function (Response){
        return Response;
      }
    }
  };

  /**
   * 扩展AJAXModelV2的回调函数
   * @param {string} anchor
   * @param {string} name
   * @param {function} callback
   */
  static extend(anchor, name, callback) {
    let callbacks = AjaxModelV2[anchor];
    switch (anchor) {
      case 'before' :
        if (!callbacks[name]) {
          callbacks[name] = callback;
        } else {
          throw new Error(`${name} before has been defined!`)
        }
        break;
      case 'after' :
        if (!callbacks[name]) {
          let newObj = {};
          set(newObj, name, callback);
          lodashMerge(callbacks, newObj);
        } else {
          throw new Error(`${name} before has been defined!`)
        }
        break;
    }
  };

  /**
   * 把对像转换成类于地址栏以=&间隔的字符串.
   * @param {object} obj 对象，包含键值对
   * @returns {string}
   */
  static serialize(obj) {
    let query = "", name, value, fullSubName, subName, subValue, innerObj, i;
    for (name in obj) {
      value = obj[name];
      if (value instanceof Array) {
        for (i = 0; i < value.length; ++i) {
          subValue = value[i];
          fullSubName = name + "[" + i + "]";
          innerObj = {};
          innerObj[fullSubName] = subValue;
          query += AjaxModelV2.serialize(innerObj) + "&";
        }
      } else if (value instanceof Object) {
        for (subName in value) {
          subValue = value[subName];
          fullSubName = name + "[" + subName + "]";
          innerObj = {};
          innerObj[fullSubName] = subValue;
          query += AjaxModelV2.serialize(innerObj) + "&";
        }
      } else if (value !== undefined && value !== null) {
        query += encodeURIComponent(name) + "=" + encodeURIComponent(value) + "&";
      }
    }
    return query.length ? query.substr(0, query.length - 1) : query;
  }
}


export default AjaxModelV2;



// WEBPACK FOOTER //
// ./src/class/AjaxModelV2.js